import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/Atomic/Atoms/Icon'

import './AiAttributionBadge.scss'

export type AiAttributionOrigin = 'generate' | 'review'

interface AiAttributionBadgeProps {
  origin: AiAttributionOrigin
  visible: boolean
}

/**
 * Temporary pill shown below the description field while an AI proposal is
 * under review. Fades in/out rather than mounting/unmounting so the field's
 * own height never shifts (see CRM-1327 implementation notes, section 4).
 */
export const AiAttributionBadge: React.FC<AiAttributionBadgeProps> = ({
  origin,
  visible,
}) => {
  const { t } = useTranslation()
  const label =
    origin === 'generate' ? t('list.generatedByAi') : t('list.aiAssisted')

  return (
    <div
      className={classNames('ai-attribution-badge', { visible })}
      aria-hidden={!visible}
    >
      <Icon icon="sparkle" color="ai" className="ai-attribution-badge-icon" />
      <span>{label}</span>
    </div>
  )
}
